import Vue from 'vue'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import router from './router'
import './gtm.js'

require('dotenv').config()

// helpers
import './helpers/mixins'
import './helpers/filters'

import { createProvider } from './vue-apollo'

require.context('./assets/stylesheets', false, /\.css$/)

Vue.config.productionTip = false

Vue.use(VueRouter)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API,
    libraries: 'places',
  },
})

// bus
const bus = new Vue()
Vue.prototype.$bus = bus

// vee validate
Vue.use(VeeValidate)

// VTooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

// pretty checkbox vue

import PrettyCheckbox from 'pretty-checkbox-vue';
import 'pretty-checkbox/src/pretty-checkbox.scss';
Vue.use(PrettyCheckbox);

// vueScrollto
import vueScrollto from 'vue-scrollto';
Vue.use(vueScrollto);

// vueSelect
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

// VueLodash
import VueLodash from 'vue-lodash';
Vue.use(VueLodash);

// datepicker

import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VCalendar from 'v-calendar'

// Use v-calendar & v-date-picker components
// Use <vc-calendar /> instead of <v-calendar />
Vue.use(VCalendar, {
    componentPrefix: 'vc'
});

Vue.use(Datetime)

// vue-moment
const moment = require('moment')
require('moment/locale/fr')

Vue.use(require('vue-moment'), {
    moment
})

new Vue({
  router,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
